import { readStates } from '@/constants/lifecycle';
import { isCommonsModeEnabled } from '@/auth/featureToggles';

const initialState = {
  datasets: {
    total: 0,
    total_private: 0,
    total_internal: 0,
    ...(isCommonsModeEnabled() && { total_public: 0 }),
    last_created_at: '',
    last_updated_at: '',
    storage_disabled_total: 0,
    me: {
      total: 0,
      total_private: 0,
      last_created_at: '',
      last_updated_at: '',
    },
  },
  searches: {
    total: 0,
    total_private: 0,
    total_internal: 0,
    last_created_at: '',
    last_updated_at: '',
    me: {
      total: 0,
      total_internal: 0,
      last_created_at: '',
      last_updated_at: '',
    },
  },
  requests: {
    total: 0,
    total_approved: 0,
    total_denied: 0,
    total_pending: 0,
    last_created_at: '',
    last_updated_at: '',
    me: {
      total: 0,
      total_approved: 0,
      total_denied: 0,
      total_pending: 0,
      last_created_at: '',
      last_updated_at: '',
    },
    review: {
      total: 0,
      total_approved: 0,
      total_denied: 0,
      total_pending: 0,
    },
  },
  ...readStates,
};

export default initialState;
